<template>
  <Layout footer>
    <div class="app-container text-base">
      <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
        <span class="mr-1">当前位置：</span>
        <NBreadcrumb>
          <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
          <NBreadcrumbItem>档案中心</NBreadcrumbItem>
        </NBreadcrumb>
      </div>
      <img class="carousel-img" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/banner11.png" />
      <div class="flex items-center my-4 zhu_yi">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/news.png" alt="" />
        <span class="mx-2 text-base font-bold">注意事项：</span>
        <span style="color: #f70707">
          管理平台属于业务主管部门及培训机构后台管理功能，学员账号无访问权限，如需开通培训机构账号请联系服务人员进行开通。
        </span>
      </div>
      <div class="mt-14 pl-6" style="text-indent: 2em">
        档案管理平台，规范了培训档案。平台可根据培训数据自动形成10项班级档案、10项个人档案及1项考核档案共21
        项培训档案。培训机构及上级管理单位可随时查阅培训电子档案,追溯培训过程，确保了培训过程有据可依，严格规范
        了培训档案，实现了创业培训过程可追溯。
      </div>
      <img class="w-full mx-auto mt-16"
        src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content11-1.png" />
      <img class="w-full mx-auto mt-24"
        src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content11-2.png" />
      <img class="w-full mx-auto mt-32"
        src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content11-3.png" />
      <div class="mt-20 pb-28">
        <div class="flex items-center">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon11-1.png" alt="" />
          <div class="ml-8">
            <p class="text-xl">班级档案（10项）</p>
            <p class="mt-3">
              开班申请表、教学计划、学员花名册、教材领用表、线下课程表、线上课程表、督导记录表、讲师考勤
              表、学员考勤表及合格情况表。
            </p>
          </div>
        </div>
        <div class="flex items-center mt-8">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon11-2.png" alt="" />
          <div class="ml-8">
            <p class="text-xl">学员档案（10项）</p>
            <p class="mt-3">
              信息登记表、个人教材领用表、身份证复印件、相关证明材料、个人线下考勤表、个人线上学习记录、
              代领协议、电子计划书、结业证书及考试试卷。
            </p>
          </div>
        </div>
        <div class="flex items-center mt-8">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon11-3.png" alt="" />
          <div class="ml-8">
            <p class="text-xl">考核档案（1项）</p>
            <p class="mt-3">考核成绩。</p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup>
import Layout from '@/components/Layout';
import { useRouter } from 'vue-router';

const router = useRouter();
function gotoHome () {
  router.push('/');
}
</script>

<style lang="scss" scoped>
.carousel-img {
  display: block;
  width: 100%;
  height: 410px;
  object-fit: cover;
}

.zhu_yi {
  border: 1px dashed #f39a1d;
  height: 60px;
  font-size: 20px;
}
</style>
